import {fetch} from '../utils/request';

// 获取openApiToken
export function getToken() {
    return fetch('cre.cresys.openapi.apptoken', {})
  }

export function logins(params) {
    return fetch('cre.cresys.ISUNG.login', params)
}

export function registers(params) {
    return fetch('cre.cresys.ISUNG.register', params)
}

export function addOpinion(params) {
    return fetch('cre.cresys.ISUNG.addOpinion', params)
}

export function getDicList(params) {
    return fetch('cre.cresys.ISUNG.apiDictionaries.list', params)
}

export function addUserMessage(params) {
    return fetch('cre.cresys.ISUNG.apiUser.add', params)
}

export function getUserMessage(params) {
    return fetch('cre.cresys.ISUNG.account.info', params)
}
export function textList(params) {
    return fetch('cre.cresys.ISUNG.apiNuMatch.list', params)
}

export function goodsList(params) {
    return fetch('cre.cresys.ISUNG.apiNuMatch.nuMatchDetailsList', params)
}

export function commentList(params) {
    return fetch('cre.cresys.ISUNG.api.userCommentsList', params)
}

export function getotherDic(params) {
    return fetch('cre.cresys.ISUNG.nutrientBasedataList', params)
}